import React from 'react'
import Snackbar from '@mui/material/Snackbar'
import Slide from '@mui/material/Slide'
import Button from '@mui/material/Button'
import DialogTitle from '@mui/material/DialogTitle'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import Grid from '@mui/material/Grid'

/**
 * usage:
  include systemFeedback: state.configReducer.systemFeedback in the mapStateToProps
  include addSystemFeedback: feedback => dispatch(addSystemFeedback(feedback)) in the mapDispatchToProps
  
  import { SystemFeedback } from '../../assets/Feedback'
  <SystemFeedback feedback={this.props.systemFeedback || ''} close={() => this.props.addSystemFeedback('')} />
 */
const SystemFeedback = props => {
  // console.log('called system feedback')
  // console.log(props)
  if(typeof props.feedback !== 'string') return null
    return (<Snackbar
        open={props.feedback !== '' ? true:false}
        autoHideDuration={4000}
        TransitionComponent={Slide}
        ContentProps={{
          'aria-describedby': 'message-id',
        }}
        action={
            <Button color="inherit" size="small" onClick={props.close || null}>
              Close
            </Button>
        }
        message={<span id="message-id">{props.feedback}</span>}
    />)
}
/**
 * usage:
  import { ConfirmBox } from '../../assets/Feedback'
  <ConfirmBox 
    confirmTitle={this.props.confirmTitle || ''}
    confirmMsg={this.props.confirmMsg || ''}
    close={() => this.props.addSystemFeedback('')} 
    confirm={() => this.function(this.props.toConfirmPayload, true)} 
    cancel={() => {
      this.props.initConfirmMessage({})
      this.props.storePayloadBeforeConfirm({})
    }} 
  />

  mapStateToProps:
  toConfirmPayload: state.configReducer.toConfirmPayload,
  confirmMessage: state.configReducer.confirmMessage,

  mapDispatchToProps:
  initConfirmMessage: msgObj => dispatch(initConfirmMessage(msgObj)),
  storePayloadBeforeConfirm: payload => dispatch(storePayloadBeforeConfirm(payload)),

  this.props.initConfirmMessage({
      title: 'Confirm delete',
      value: 'You are about to delete the contact, please confirm.'
  })
  this.props.storePayloadBeforeConfirm(yourPayload)

 */
const ConfirmBox = props => {
  return(<Dialog aria-labelledby="simple-dialog-title" open={props.confirmMsg ? true: false}>
    <DialogTitle id="simple-dialog-title">{props.confirmTitle || 'System message'}</DialogTitle>
    <DialogContent>
    {props.component !== null ? 
      props.component
      :
      <DialogContentText id="alert-dialog-description">{props.confirmMsg || 'Please confirm you action.'}</DialogContentText>
    }
    {/*<DialogContentText id="alert-dialog-description">{props.confirmMsg || 'Please confirm you action.'}</DialogContentText>*/}
    </DialogContent>
    <DialogActions>
      <Button onClick={() => props.cancel()} color="primary">
        Cancel
      </Button>
      <Button onClick={() => props.confirm()} color="primary" autoFocus>
        Confirm
      </Button>
    </DialogActions>
  </Dialog>)
}

export { SystemFeedback, ConfirmBox }